"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _dexie = _interopRequireDefault(require("dexie"));
var _Message = _interopRequireDefault(require("./Modals/Message"));
var _Store = require("../Store");
var _dates = require("../Helpers/dates");
var _threadFilter = require("../Helpers/threadFilter");
var _XMPPEventEmitter = require("../XMPPEventEmitter/XMPPEventEmitter");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /* eslint-disable promise/no-return-wrap */ /* eslint-disable max-lines */ /* global window */
var DB_VERSION_THREE = 3;
var DB_VERSION_FOUR = 4;
var DB_VERSION_FIVE = 5;
var ChatDatabase = exports.default = /*#__PURE__*/function () {
  function ChatDatabase(store) {
    var _this = this;
    (0, _classCallCheck2.default)(this, ChatDatabase);
    (0, _defineProperty2.default)(this, "isThreadExpired", function (thread) {
      var messageTTLDays = window.localStorage.getItem('message_ttl_days');
      var threadLastMessageTimestamp = thread.lastMsgTimestamp || thread.last_msg_timestamp;
      var isExpired = false;
      if (threadLastMessageTimestamp) {
        threadLastMessageTimestamp = parseInt(threadLastMessageTimestamp, 10);
        var diff = !isNaN(threadLastMessageTimestamp) && (0, _dates.daysOnlyDiff)(new Date(threadLastMessageTimestamp), new Date());
        if (messageTTLDays && diff && diff > parseInt(messageTTLDays, 10)) {
          isExpired = true;
        }
      }
      return isExpired;
    });
    (0, _defineProperty2.default)(this, "deleteExpiredThreadsAndMessages", function () {
      var itemsToDelete = [];
      return _this.db.threads.toArray().then(function (threads) {
        threads.forEach(function (thread) {
          if (_this.isThreadExpired(thread)) {
            itemsToDelete.push("".concat(thread.id));
          }
        });
        return _dexie.default.Promise.all([_this.db.messages.where('userItemId').anyOf(itemsToDelete).delete(), _this.db.threads.where('id').anyOf(itemsToDelete).delete()]);
      }).catch(
      // eslint-disable-next-line handle-callback-err, no-unused-vars
      function (err) {
        // window.newrelic?.addPageAction('error_in_deleting_expired_threads', {
        //     err
        // });

        return Promise.resolve();
      });
    });
    (0, _defineProperty2.default)(this, "isBuyThread", function (userId, itemId, myUserId) {
      var messages = _this.getThreadsById(userId, itemId) || [];
      return messages.length ? messages[0].sellerId !== myUserId : true;
    });
    (0, _defineProperty2.default)(this, "getBuyThreads", function (threads) {
      return threads.filter(function (thread) {
        return _this.isBuyThread(thread.userId, thread.itemId, thread.myUserId);
      });
    });
    this.db = new _dexie.default('chat');
    this.db.version(1).stores({
      messages: 'id,body,itemId,from,to,date',
      users: 'id'
    });
    this.store = store;
    this.db.version(2).stores({
      messages: 'id,body,itemId,from,to,date,userId,[userId+itemId]',
      users: 'id'
    }).upgrade(function (trans) {
      trans.messages.toCollection().modify(function (message) {
        message.userId = message.isMine ? message.to : message.from;
      });
    });
    this.db.version(DB_VERSION_THREE).stores({
      messages: 'id,body,itemId,from,to,date,userId,userItemId',
      users: 'id'
    }).upgrade(function (trans) {
      trans.messages.toCollection().modify(function (message) {
        message.userItemId = "".concat(message.userId, "_").concat(message.itemId);
      });
    });
    this.db.version(DB_VERSION_FOUR).stores({
      messages: 'id,body,itemId,from,to,date,userId,userItemId',
      threads: 'id,itemId,userId,lastMsgTimestamp,bDidLoadMessages,bNeedsUpdate,myUserId',
      users: 'id'
    });
    this.db.version(DB_VERSION_FIVE).stores({
      questions: 'userItemId, itemId, userId, segmentedQuestions, lastSyncTime'
    });
    this.db.open().then(function () {}).catch(function (e) {
      return console.error("error in on receive functionsss", e);
    }); // eslint-disable-line
  }
  (0, _createClass2.default)(ChatDatabase, [{
    key: "getLastMessageByThread",
    value: function getLastMessageByThread(otherUser, itemId) {
      var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
      var messages = this.getThreadsById(otherUser, itemId) || [];
      messages.sort(function (a, b) {
        return a.date - b.date;
      });
      callback();
      return messages[messages.length - 1];
    }
  }, {
    key: "getMessages",
    value: function getMessages() {
      var state = this.store.getState() || {};
      return state && state.chat && state.chat.messages;
    }
  }, {
    key: "getUsersFromStore",
    value: function getUsersFromStore() {
      var state = this.store.getState() || {};
      return state && state.chat && state.chat.users;
    }
  }, {
    key: "getThreadsFromStore",
    value: function getThreadsFromStore() {
      var state = this.store.getState() || {};
      return state && state.chat && state.chat.threadMessages;
    }
  }, {
    key: "getTransactionThreads",
    value: function getTransactionThreads(state, threads) {
      var _state$features, _state$features$trans;
      var transactionNode = (_state$features = state.features) === null || _state$features === void 0 ? void 0 : (_state$features$trans = _state$features.transaction_inbox) === null || _state$features$trans === void 0 ? void 0 : _state$features$trans.chat_inbox;
      var transactionThreads = threads.filter(function (thread) {
        return (0, _threadFilter.featureHelper)(transactionNode, thread.categoryId, thread.dealerType);
      });
      return this.getBuyThreads(transactionThreads);
    }
  }, {
    key: "getNewThreads",
    value: function getNewThreads() {
      var isTransaction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var state = this.store.getState() || {};
      var threads = state && state.chat && state.chat.threads;
      return isTransaction ? this.getTransactionThreads(state, threads) : threads;
    }
  }, {
    key: "getThreadsById",
    value: function getThreadsById(userId, itemId) {
      var state = this.getThreadsFromStore();
      return state && state["".concat(userId, "_").concat(itemId)];
    }
  }, {
    key: "getUnreadThreads",
    value: function getUnreadThreads(userId, callback) {
      var _this2 = this;
      var count = 0;
      var messages = this.getThreadsFromStore();
      if (messages) {
        Object.keys(messages).forEach(function (userItems) {
          var userData = userItems.split('_');
          var unreadCount = _this2.getUnreadCountByThread(userData[0], userData[1]);
          count += unreadCount;
        });
      }
      callback(count);
    }
  }, {
    key: "getUnreadThreadsWithData",
    value: function getUnreadThreadsWithData(userId, callback) {
      var _this3 = this;
      var isTransaction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var count = 0;
      var threads = this.getNewThreads(isTransaction);
      if (threads && threads.length) {
        threads.map(function (thread) {
          var unreadCount = _this3.getUnreadCountByThread(thread.userId, thread.itemId);
          count += unreadCount;
        });
      }
      callback(count);
    }
  }, {
    key: "getNewReceivedSystemMessages",
    value: function getNewReceivedSystemMessages() {
      var messages = Object.values(this.getMessages());
      return messages.filter(function (message) {
        return message.system && !message.received;
      });
    }
  }, {
    key: "getUnreadCountByThread",
    value: function getUnreadCountByThread(otherUser, itemId) {
      var messages = this.getThreadsById(otherUser, itemId) || [];
      return messages.reduce(function (prev, msg) {
        return prev + (msg.info || msg.displayed || msg.isMine ? 0 : 1);
      }, 0);
    }

    // No need to revamp
  }, {
    key: "getDistinctConversationId",
    value: function getDistinctConversationId(otherUser) {
      return this.db.messages.where('userId').equals(otherUser).toArray().then(function (messages) {
        return messages.map(function (message) {
          return message.itemId;
        }).filter(function (value, index, self) {
          return self.indexOf(value) === index;
        });
      });
    }
  }, {
    key: "getUserBuyIntentThreads",
    value: function getUserBuyIntentThreads(userId, callback) {
      var list = this.getNewThreads();
      callback(list);
    }
  }, {
    key: "getThreads",
    value: function getThreads(userId, callback) {
      var _this4 = this;
      var threads = [];
      var messages = this.getThreadsFromStore();
      if (messages) {
        threads = Object.keys(messages).map(function (userItems) {
          var userData = userItems.split('_');
          var lastMessage = _this4.getLastMessageByThread(userData[0], userData[1]);
          var unreadCount = _this4.getUnreadCountByThread(userData[0], userData[1]);
          return {
            userId: userData[0],
            lastMessage: lastMessage,
            unreadCount: unreadCount,
            itemId: userData[1]
          };
        });
      }
      threads.sort(function (a, b) {
        return b.lastMessage.date - a.lastMessage.date;
      });
      callback(threads);
    }
  }, {
    key: "getThreadMessages",
    value: function getThreadMessages(otherUser, itemId, callback) {
      var msg = this.getThreadsById(otherUser, itemId) || [];
      msg.sort(function (a, b) {
        return a.date - b.date;
      });
      return callback(msg);
    }
  }, {
    key: "getUsers",
    value: function getUsers(userId, callback) {
      var users = this.getUsersFromStore();
      var newUsers = _objectSpread({}, users);
      delete newUsers[userId];
      callback(newUsers);
    }
  }, {
    key: "getUser",
    value: function getUser(id) {
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      var users = this.getUsersFromStore() || {};
      callback(users[id]);
    }
  }, {
    key: "addUser",
    value: function addUser(user) {
      this.store.dispatch({
        type: 'SAVE_USER',
        data: {
          user: user
        }
      });
      return this.db.users.add(user);
    }
  }, {
    key: "getItems",
    value: function getItems() {
      var userItems = Object.keys(this.getThreadsFromStore());
      var itemList = {};
      userItems.forEach(function (userItem) {
        itemList[userItem.split('_')[1]] = true;
      });
      return Object.keys(itemList);
    }
  }, {
    key: "getMessageById",
    value: function getMessageById(messageId, callback) {
      var messages = this.getMessages() || {};
      return callback(messages[messageId]);
    }
  }, {
    key: "getMessageDataById",
    value: function getMessageDataById(messageId) {
      var messages = this.getMessages() || {};
      return messages[messageId];
    }
  }, {
    key: "addMessage",
    value: function addMessage(message) {
      if (message instanceof _Message.default) {
        (0, _Store.saveMessage)(this.store, {
          message: message,
          itemId: message.itemId,
          userId: message.userId
        });
        (0, _Store.isFirstMessageSend)(this.store, true);
        return this.db.messages.put(message);
      }
      return null;
    }
  }, {
    key: "addMessages",
    value: function addMessages(messages) {
      var _this5 = this;
      (0, _Store.saveMessages)(this.store, {
        messages: messages
      });
      return messages.map(function (message) {
        return _this5.db.messages.put(message);
      });
    }

    /**
     * Returns an array of promises for the insert/update of each userItemId-topic combination
     * @param {*} userId
     * @param {*} itemId
     * @param {*} segmentedQuestions
     */
  }, {
    key: "addQuestions",
    value: function addQuestions(userId, itemId, segmentedQuestions) {
      var userItemId = "".concat(userId, "_").concat(itemId);
      var lastSyncTime = Date.now();
      (0, _Store.saveQuestionsToStore)(this.store, (0, _defineProperty2.default)({}, userItemId, {
        lastSyncTime: lastSyncTime,
        userId: userId,
        itemId: itemId,
        segmentedQuestions: segmentedQuestions
      }));
      return this.db.questions.put({
        userItemId: userItemId,
        userId: userId,
        itemId: itemId,
        segmentedQuestions: segmentedQuestions,
        lastSyncTime: lastSyncTime
      });
    }
  }, {
    key: "placeQuestionsFromDBToStore",
    value: function placeQuestionsFromDBToStore() {
      var _this6 = this;
      this.db.questions.toArray().then(function (questionCloudArr) {
        if (questionCloudArr && questionCloudArr.length) {
          (0, _Store.initQuestionCloudInStore)(_this6.store, questionCloudArr);
        }
        return Promise.resolve();
      }).catch(
      // eslint-disable-next-line handle-callback-err, no-unused-vars
      function (err) {
        // if (typeof window !== 'undefined') {
        //     window.newrelic?.addPageAction('error_in_retreiving_question_cloud_from_db', {
        //         err
        //     });
        // }
        return Promise.resolve();
      });
    }
  }, {
    key: "addThreads",
    value: function addThreads(threads) {
      var _this7 = this;
      (0, _Store.saveThreads)(this.store, {
        threads: threads
      });
      return threads.map(function (thread) {
        return _this7.db.threads.put(thread);
      });
    }
  }, {
    key: "updateThread",
    value: function updateThread(threadId, updates) {
      (0, _Store.updateThread)(this.store, {
        threadId: threadId,
        updates: updates
      });
      return this.db.threads.update(threadId, updates);
    }
  }, {
    key: "addThread",
    value: function addThread(thread) {
      (0, _Store.saveThreads)(this.store, {
        threads: [thread]
      });
      return this.db.threads.put(thread);
    }
  }, {
    key: "findThread",
    value: function findThread(message) {
      var _this8 = this;
      var threads = this.getNewThreads();
      var userId = message.userId;
      var itemId = message.itemId;
      if (threads) {
        var hasThread = threads.find(function (thread) {
          return thread.userId === userId && thread.itemId === itemId;
        });
        if (hasThread) {
          if (hasThread.lastMsgTimestamp) {
            hasThread.lastMsgTimestamp = message.date;
            this.updateDBThreadTimestamp(hasThread.id, hasThread.lastMsgTimestamp);
          }
          return Promise.resolve(true);
        }
      }
      return this.db.threads.where('id').equals("".concat(userId, "_").concat(itemId)).toArray().then(function (thread) {
        if (thread && thread.length) {
          _this8.updateDBThreadTimestamp(thread[0].id, message.date);
          return true;
        }
        return false;
      });
    }
  }, {
    key: "findThreadById",
    value: function findThreadById(userId, itemId) {
      return this.db.threads.where('id').equals("".concat(userId, "_").concat(itemId)).toArray();
    }
  }, {
    key: "updateDBThreadTimestamp",
    value: function updateDBThreadTimestamp(threadId, lastMsgTimestamp) {
      return this.db.threads.update(threadId, {
        lastMsgTimestamp: lastMsgTimestamp
      });
    }
  }, {
    key: "fetchData",
    value: function fetchData(userId) {
      var _this9 = this;
      return this.db.messages.toArray().then(function (userMessages) {
        var toBeDeletedMessages = userMessages.filter(function (message) {
          return message.to !== userId && message.from !== userId;
        });
        var messages = userMessages.filter(function (message) {
          return message.to === userId || message.from === userId;
        });
        toBeDeletedMessages.forEach(function (message) {
          // window.newrelic?.addPageAction('message_mismatch', {
          //     user_id: userId,
          //     to_id: message.to,
          //     from_id: message.from,
          //     message_id: message.id,
          //     message
          // });
          _this9.removeMessage(message.id);
        });
        (0, _Store.saveMessages)(_this9.store, {
          messages: messages
        });
      });
    }
  }, {
    key: "fetchMessageData",
    value: function fetchMessageData(userId) {
      return this.fetchData(userId);
    }
  }, {
    key: "fetchThreadData",
    value: function fetchThreadData(userId) {
      var _this10 = this;
      return this.db.threads.toArray().then(function (userThreads) {
        var toBeDeletedThreads = userThreads.filter(function (thread) {
          return thread.myUserId !== userId;
        });
        var threads = userThreads.filter(function (thread) {
          return thread.myUserId === userId;
        });
        toBeDeletedThreads.forEach(function (thread) {
          // window.newrelic?.addPageAction('thread_mismatch', {
          //     user_id: userId,
          //     thread_id: thread.id
          // });
          _this10.removeThread(thread.userId, thread.itemId);
        });
        (0, _Store.saveThreads)(_this10.store, {
          threads: threads
        });
      });
    }
  }, {
    key: "syncUserData",
    value: function syncUserData() {
      var _this11 = this;
      return this.db.users.toArray().then(function (users) {
        users.forEach(function (user) {
          _this11.store.dispatch({
            type: 'SAVE_USER',
            data: {
              user: user
            }
          });
        });
      });
    }
  }, {
    key: "getLastMessageTimeStamp",
    value: function getLastMessageTimeStamp() {
      return this.db.messages.orderBy('date').reverse().limit(1).toArray().then(function (messages) {
        return messages[0];
      }).then(function (message) {
        return message && message.date;
      });
    }
  }, {
    key: "markReceived",
    value: function markReceived(messageId, callback) {
      var messages = this.getMessages() || {};
      var message = messages[messageId];
      if (message) {
        var newMessage = _objectSpread(_objectSpread({}, message), {}, {
          received: true
        });
        (0, _Store.saveMessage)(this.store, {
          message: newMessage,
          itemId: newMessage.itemId,
          userId: newMessage.userId
        });
      }
      callback();
      return this.db.messages.update(messageId, {
        received: true
      }).catch(function (e) {
        return console.log(e);
      }); // eslint-disable-line
    }
  }, {
    key: "markDisplayed",
    value: function markDisplayed(messageId, callback) {
      var messages = this.getMessages() || {};
      var message = messages[messageId];
      if (message) {
        var newMessage = _objectSpread(_objectSpread({}, message), {}, {
          displayed: true
        });
        (0, _Store.saveMessage)(this.store, {
          message: newMessage,
          itemId: newMessage.itemId,
          userId: newMessage.userId
        });
      }
      callback();
      return this.db.messages.update(messageId, {
        displayed: true
      }).catch(function (e) {
        return console.log("cant mark", e);
      }); // eslint-disable-line
    }
  }, {
    key: "addSuggestions",
    value: function addSuggestions(messageId, suggestions, callback) {
      var messages = this.getMessages() || {};
      var message = messages[messageId];
      if (message) {
        var newMessage = _objectSpread(_objectSpread({}, message), {}, {
          suggestions: suggestions
        });
        (0, _Store.saveMessage)(this.store, {
          message: newMessage,
          itemId: newMessage.itemId,
          userId: newMessage.userId
        });
      }
      callback(message, suggestions);
      return this.db.messages.update(messageId, {
        suggestions: suggestions
      });
    }
  }, {
    key: "setTipForMessage",
    value: function setTipForMessage(messageId, systemMessageData) {
      var messages = this.getMessages() || {};
      var message = messages[messageId];
      if (message) {
        var newMessage = _objectSpread(_objectSpread({}, message), {}, {
          systemMessageData: systemMessageData
        });
        (0, _Store.saveMessage)(this.store, {
          message: newMessage,
          itemId: newMessage.itemId,
          userId: newMessage.userId
        });
      }
      return this.db.messages.update(messageId, {
        systemMessageData: systemMessageData
      });
    }
  }, {
    key: "markMessageAsReplied",
    value: function markMessageAsReplied(messageId, callback) {
      var messages = this.getMessages() || {};
      var message = messages[messageId];
      if (message) {
        var newMessage = _objectSpread(_objectSpread({}, message), {}, {
          hasReplied: true
        });
        (0, _Store.saveMessage)(this.store, {
          message: newMessage,
          itemId: newMessage.itemId,
          userId: newMessage.userId
        });
      }
      callback();
      return this.db.messages.update(messageId, {
        hasReplied: true
      });
    }
  }, {
    key: "updatePresence",
    value: function updatePresence(userId, type) {
      var users = this.getUsersFromStore();
      if (users && users[userId]) {
        var user = users[userId];
        var newUser = _objectSpread(_objectSpread({}, user), {}, {
          presence: type
        });
        this.store.dispatch({
          type: 'SAVE_USER',
          data: {
            user: newUser
          }
        });
        _XMPPEventEmitter.XMPPEventEmitter.dispatch('onUserUpdate', newUser);
        return this.db.users.update(user, {
          presence: type
        }).catch(function (e) {
          return console.log(e);
        }); // eslint-disable-line
      }
      _XMPPEventEmitter.XMPPEventEmitter.dispatch('onUserUpdate');
      return null;
    }
  }, {
    key: "updateBlock",
    value: function updateBlock(userId, isBlock) {
      var users = this.getUsersFromStore();
      if (users && users[userId]) {
        var user = users[userId];
        var newUser = _objectSpread(_objectSpread({}, user), {}, {
          isBlock: isBlock
        });
        this.store.dispatch({
          type: 'SAVE_USER',
          data: {
            user: newUser
          }
        });
        _XMPPEventEmitter.XMPPEventEmitter.dispatch('onUserUpdate', newUser);
        return this.db.users.update(userId, {
          isBlock: isBlock
        }).catch(function (e) {
          return console.log(e);
        }); // eslint-disable-line
      }
      _XMPPEventEmitter.XMPPEventEmitter.dispatch('onUserUpdate');
      return null;
    }
  }, {
    key: "deleteUserChats",
    value: function deleteUserChats(userId, itemId) {
      this.store.dispatch({
        type: 'REMOVE_MESSAGES',
        data: {
          itemId: itemId,
          userId: userId
        }
      });
      if (itemId) {
        return _dexie.default.Promise.all([this.db.messages.where('userItemId').equals("".concat(userId, "_").concat(itemId)).delete(), this.db.threads.where('id').equals("".concat(userId, "_").concat(itemId)).delete()]);
      }
      return _dexie.default.Promise.all([this.db.messages.where('userId').equals(userId).delete(), this.db.threads.where('userId').equals(userId).delete()]);
    }
  }, {
    key: "deleteBulkUserChats",
    value: function deleteBulkUserChats(userItems) {
      this.store.dispatch({
        type: 'REMOVE_BULK_MESSAGES',
        data: userItems
      });
      var itemsToDelete = Object.values(userItems).map(function (userItem) {
        return "".concat(userItem.userId, "_").concat(userItem.itemId);
      });
      return _dexie.default.Promise.all([this.db.messages.where('userItemId').anyOf(itemsToDelete).delete(), this.db.threads.where('id').anyOf(itemsToDelete).delete()]);
    }
  }, {
    key: "removeThread",
    value: function removeThread(userId, itemId) {
      this.deleteUserChats(userId, itemId);
    }
  }, {
    key: "removeMessage",
    value: function removeMessage(messageId) {
      return this.db.messages.where('id').equals(messageId).delete();
    }
  }, {
    key: "removeMessageBySync",
    value: function removeMessageBySync(messageId) {
      var message = this.getMessageDataById(messageId);
      if (message) {
        this.store.dispatch({
          type: 'REMOVE_MESSAGE',
          data: {
            userId: message.userId,
            itemId: message.itemId,
            messageId: messageId
          }
        });
      }
      return this.removeMessage(messageId);
    }
  }, {
    key: "resetUserPresence",
    value: function resetUserPresence(userId) {
      var _this12 = this;
      var users = this.getUsersFromStore();
      var newUsers = _objectSpread({}, users);
      delete newUsers[userId];
      Object.values(newUsers).forEach(function (user) {
        var updatedUser = _objectSpread(_objectSpread({}, user), {}, {
          presence: 'unavailable'
        });
        _this12.store.dispatch({
          type: 'SAVE_USER',
          data: {
            user: updatedUser
          }
        });
      });
      return this.db.users.where('id').notEqual(userId).modify(function (user) {
        user.presence = 'unavailable';
      }).catch(function (e) {
        return console.log(e);
      }); // eslint-disable-line
    }
  }, {
    key: "searchMessages",
    value: function searchMessages(text) {
      var messages = Object.values(this.getMessages());
      var regex = new RegExp(text, 'gi');
      return messages.filter(function (x) {
        return !x.info && !x.call && !x.sms && !x.image && !x.location && !x.voice && !x.system && regex.test(x.body);
      }).reverse().sort(function (a, b) {
        return b.date - a.date;
      });
    }
  }, {
    key: "getNewMessage",
    value: function getNewMessage() {
      return new _Message.default();
    }
  }, {
    key: "cleanDb",
    value: function cleanDb() {
      return this.db.delete();
    }
  }, {
    key: "clearMessages",
    value: function clearMessages() {
      return this.db.messages.clear();
    }
  }, {
    key: "clearThreads",
    value: function clearThreads() {
      return this.db.threads.clear();
    }
  }]);
  return ChatDatabase;
}();